import { render, staticRenderFns } from "./CopyStakeWheelOfFortuneCampaignDialogTotalRow.vue?vue&type=template&id=186443f8&scoped=true&lang=pug"
import script from "./CopyStakeWheelOfFortuneCampaignDialogTotalRow.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWheelOfFortuneCampaignDialogTotalRow.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWheelOfFortuneCampaignDialogTotalRow.vue?vue&type=style&index=0&id=186443f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186443f8",
  null
  
)

export default component.exports